import { Modal } from 'antd';
import React, { Fragment } from 'react';

const YoutubeVideoPlayerV2: React.FC<{
    currVideoId: string | undefined;
    closeModal: () => void;
    visible?: boolean;
}> = ({ closeModal, currVideoId, visible = false }) => {
    return (
        <Fragment>
            <Modal
                closeIcon={() => null}
                closable={false}
                destroyOnClose
                visible={visible}
                centered
                footer={
                    <div className="flex py-8 items-center w-full justify-end">
                        <div
                            onClick={closeModal}
                            className="px-16 py-8 btn-small cursor-pointer rounded-8 bg-darwin-accent-bright-blue-800 text-white text-14 font-700"
                        >
                            Close
                        </div>
                    </div>
                }
                bodyStyle={{
                    padding: 0,
                    height: 476,
                    borderRadius: 4,
                    overflowY: 'auto',
                    maxHeight: 'calc(100vh - 200px)',
                }}
                onCancel={closeModal}
                width="65%"
                className="abha-video"
            >
                <iframe
                    className="w-full h-full rounded-4"
                    id="ytplayer"
                    src={`https://youtube.com/embed/${currVideoId}?autoplay=1&mute=1`}
                    title="Eka youtube video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
            </Modal>
        </Fragment>
    );
};

export default YoutubeVideoPlayerV2;
